import React from "react";
import CheckedIcon from "../../src/assests/Checked.svg";

const CustomRadioButton = ({ id, name, checked, label, value, onChange }) => {
  return (
    <label
      htmlFor={id}
      className="inline-flex items-center cursor-pointer text-[.9rem] text-nowrap text-text-primary"
    >
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="hidden"
        value={value}
      />
      <div
        className={`min-w-7 flex font-bold text-sm text-text-primary justify-center h-7 items-center border border-edge mr-2 rounded-full transition-all duration-200 ${
          checked
            ? "bg-gradient-to-br from-emerald-500 to-emerald-600 border-transparent shadow-sm"
            : "bg-input-bg hover:border-indigo-400/40"
        }`}
      >
        {checked && (
          <img alt="checkMark" src={CheckedIcon} className="w-4 h-3" />
        )}
      </div>
      {label}
    </label>
  );
};

export default CustomRadioButton;
